module.exports = __webpack_public_path__ + "media/images/logo-white-76d2c559022d78597137d88deaca7562.svg";